'use client';

import { useEffect } from 'react';

import { useSetCurrentResolvedSearch } from '@/src/lib/hooks/query';
import type { PartialDeep } from 'type-fest';
import type { HpResolvedStateDto } from '@zg-rentals/ts-hotpads-api-client';

type Props = {
  resolved: PartialDeep<HpResolvedStateDto> | null;
};

// Seeds the SRP's BE-resolved search state (effectiveFilters / resolvedSlug /
// slugDefaults) into the shared cache for the persistent shell.
export function ResolvedSearchHydrator({ resolved }: Props) {
  const setResolved = useSetCurrentResolvedSearch();

  useEffect(() => {
    setResolved(resolved);
  }, [resolved, setResolved]);

  return null;
}
